var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatchupper01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-222{fill:#fff;stroke:#010101;stroke-miterlimit:10;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M283.29,385.28l-124.63,2.09c-28.73.48-52.25-22-52.55-50.21l-2-193.68,228.65-3.83,2,193.67C335.06,361.54,312,384.79,283.29,385.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatchupper01);
export default __webpack_public_path__ + "static/media/PATCH UPPER-01.c98d4c1616334db86a79d18ffb6a929e.svg";
export { ForwardRef as ReactComponent };